export default __webpack_public_path__ + "static/media/Hair_9_M_C2.19f19a50.svg";